import { gql } from "@apollo/client";
import { TypeDefinitionAttributeFields } from "../fragments/typeDefinitionAttribute";

export const InstalledBaseEventListTDAs = gql`
    query InstalledBaseEventListTDAs (
        $id: ID!,
        $typeDefinitionIndex: InstalledBaseEventTypeDefinitionIndex!,
        $options: InstalledBaseEventTypeDefinitionAttributeListOptionsInput
    ) {
        installedBaseNode (id: $id) {
            id
            installedBaseEventList {
                typeDefinitionAttributeList (typeDefinitionIndex: $typeDefinitionIndex, options: $options) {
                    typeDefinitionAttributes {
                        ...TypeDefinitionAttributeFields
                    }
                }
            }
        }
    }
    ${TypeDefinitionAttributeFields}
`;
